import Icons from "../../../shared/constants/icon.constant";
import assetRoutes from "../groups/assets/routes/assets.routes";
import investmentsRoutes from "../groups/investments/routes/investments.routes";
import learningRoutes from "../groups/learning/routes/learning.routes";
import tradeRoutes from "../groups/trade/routes/trade.routes";
import AdminLayout from "../layouts/AdminLayout";
import Dashboard from "../pages/Dashboard";
import ComingSoon from "@/shared/components/ComingSoon";
import profileRoutes from "../../profile/routes/profile.route";
import ProtectedRoute from "@/shared/components/guards/ProtectedRoute";
import OnboardingGuard from "@/shared/components/guards/OnboardingGuard";

const adminRoutes = {
  path: "/",
  element: (
    <ProtectedRoute>
      <OnboardingGuard>
        <AdminLayout />
      </OnboardingGuard>
    </ProtectedRoute>
  ),
  children: [
    {
      path: "dashboard",
      label: "Dashboard",
      icon: Icons.Dashboard({ width: 16, height: 16 }),
      element: <Dashboard />,
    },
    profileRoutes,
    { ...tradeRoutes, hideChildren: true, comingSoon: true },
    { ...investmentsRoutes, hideChildren: true, comingSoon: true },
    assetRoutes,
    { ...learningRoutes, hideChildren: true, sidebarPath: "learning/courses" },
    {
      path: "dashboard/notifications",
      label: "Notifications",
      icon: Icons.Notifications({ width: 16, height: 16 }),
      element: <ComingSoon />,
      comingSoon: true,
    },
  ],
};

export default adminRoutes;
